import React from 'react';
import { Navigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

/**
 * Marketing landing pages are web-only. Native Capacitor shells skip straight to the app.
 */
const WebOnlyLandingRoute = ({ children }) => {
  if (Capacitor.isNativePlatform()) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default WebOnlyLandingRoute;
